import { Component, input } from '@angular/core';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';
import { NamePositionEmailData } from './name-position-email-display.models';

@Component({
  selector: 'app-name-position-email-display',
  imports: [LabeledContentComponent],
  templateUrl: './name-position-email-display.component.html',
  styleUrl: './name-position-email-display.component.scss',
})
export class NamePositionEmailDisplayComponent {
  namePositionEmailData = input.required<NamePositionEmailData>();
}
